/* eslint-disable */
import Vue from 'vue'
import $ from 'webpack-zepto';
import { Toast } from 'vant';
import {getQueryString,type,getQueryObject } from './util/util'
import jumpMgr from './task/jumpMgr'
import taskMgr from './task/taskMgr'
import storage from  './util/CacheStorage.js'
import SupremePlugin from './reuse/plugins/SupremePlugin'
import Loading from './components/loading';
/**
 *@exports supreme
 *@desc 封装superme 主要的公用方法,并对vue进行基础扩展,加载全局组件等等
 *@author lei.you
 *@date 2018/02/08
 * */
var supreme ={
  /**
   * @property {jquery} $
   * */
  $:$,
    /**
     * @property {boolean} isInWebView
     * */
  isInWebView:isInWebview(),
    /**
     * @property {boolean} isInWeb
     * */
  isInWeb:!window._toolkit,
    /**
     * @property {boolean} inPad
     * */
  inPad:false,
    /**
     * @property {boolean} isIOS
     * */
  isIOS:false,
    /**
     * @property {boolean} isAndroid
     * */
  isAndroid:false,
    /**
     * @property {boolean} $
     * */
  productionTip:false,
    /**
     * @property {vue} 公用事件总线
     * */
  //公用总线
  pubHubus:new Vue(),
    /**
     * @property {storage}  一个封装过的storage 解决存储时间和序列号的问题
     * */
  cache:storage,
    /**
     * @property {storage} localstorage
     * */
  localCache:storage.getInstance({storage:"localStorage"}),
    /**
     * @property {storage} sessionstorage
     * */
  sessionCache:storage.getInstance({storage:"sessionStorage"}),
    /**
     * @property {vant} toast
     * */
  toast:Toast,
    /**
     * @property {router} app程序的router
     * */
  $router:null,
    /**
     * @property {mint-ui} indicator
     * */
  indicator: Loading,

  init(config){
    $.extend(this,config);
    jumpMgr.init(config);
  },
    /**
     * @return long 时间戳
     * */
  getTimestamp(){
    return Date.parse(new Date());
  },
  /**
   * @param {string} param key 参数名
   * @return {string} 获取url上的参数
   * */
  getQueryString(key){
    return getQueryString(key);
  },
  /**
   *
   * @return 获取url上的参数对象
   * */
  getQueryObject(){
    return getQueryObject();
  },
  /**
   * @param {string||object} msg
   * @desc 提供一个最常用的toast 其他功能的toast 请直接使用 this.toast
   * */

  showToast(msg){
    if(type.isObject(msg)){
      this.toast(JSON.stringify(msg))
    }
    this.toast(msg)
  },
  /**
   * @param {string||object}  msg
   * @desc 提供一个最简单最常用的loading 用法
   * */
  //
  showLoading(msg){
    if(type.isString(msg)){
      this.indicator.open(msg);
    }
    if(type.isObject(msg)){
      this.indicator.open(msg);
    }
    return this;
  },
    /**
     * @desc 隐藏loading效果
     * */
  hideLoading(){
    this.indicator.close();
    return this;
  },
    /**
     * @desc 辅助跳转，跳转不会记录到taskStack 中
     * @param {string}  pathName 跳转的路由名称
     * @param {object}  params 跳转携带的参数
     * @return {supreme} 返回supreme 本身
     *
     * */
  forward(pathName,params){
    jumpMgr.forward(pathName,params);
    return this;
  },
    /**
     * @desc 跳转功能，跳转会记录到taskStack中
     * @param {string}  跳转的路由名称
     * @param {object}  跳转携带的参数
     * @return {supreme} supreme 返回supreme 本身
     *
     * */
    goto(pathName,params){
    if(!this.$router){
      this.showToast("请先初始化supreme 的$router 后使用改方法")
    }
    jumpMgr.goto(pathName,params);
    return this;
  },
    /**
     * @desc 最常用回退功能
     * @param {object}  回退携带的参数
     * @return {supreme} 返回supreme 本身
     *
     * */
  back(params){
    if(!this.$router){
      this.showToast("请先初始化supreme 的$router 后使用改方法")
    }
    jumpMgr.back(params);
    return this;
  },
    /**
     * @desc 指定页面，或者步数的回退功能
     * @param {object}  model ={
     *            step, 指定回退 步数  正整数
     *            name, 指定回退到最近的指定名字的task
     *            step name 不能同时指定，如果同时指定会优先step
     *            clearCache true false 是否清缓存
     *          }
     * @parmas {object}  回退携带的参数
     * @return {supreme} 返回supreme 本身
     *
     * */
  backToPage(model,params){
    if(!this.$router){
      this.showToast("请先初始化supreme 的$router 后使用改方法")
    }
    jumpMgr.backToPage(model,params);
    return this;
  },
    /**
     *
     * @desc 清除taskStack 和 本地缓存的中浏览历史 ，慎用
     *
     * */
  //辅助清除历史
  clearHistory(){
    taskMgr.clear();
    return this;
  }

}

// try {
//   var testKey = guid.getGuid()
//   localStorage.setItem(testKey,testKey);
//   localStorage.removeItem(testKey);
//   $(window).unload=function(){
//     alert('unload........');
//   };
// } catch(e) {
//   supreme.showToast("supreme 框架暂时不支持隐身模式");
// }
function  isInWebview () {
  var ua = navigator.userAgent.toLowerCase()
  if (ua.match(/MicroMessenger/i) == 'micromessenger') { // 微信浏览器判断
    return false
  } else if (ua.match(/QQ/i) == 'qq') { // QQ浏览器判断
    return false
  } else if (ua.match(/WeiBo/i) == "weibo") {
    return false
  } else {
    if (ua.match(/Android/i) != null) {
      return ua.match(/browser/i) == null
    } else if (ua.match(/iPhone/i) != null) {
      return ua.match(/safari/i) == null
    } else {
      return (ua.match(/macintosh/i) == null && ua.match(/windows/i) == null)
    }
  }
}
// 有关vue 全局添加的方法
Vue.use(SupremePlugin);
export default supreme
